import {
  ChangeDetectorRef,
  Directive,
  HostListener,
  Input,
  OnDestroy,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MatButton,
  MatFabButton,
  MatIconButton,
  MatMiniFabButton,
} from '@angular/material/button';
import { isNonNullable } from '@qtek/shared/utils';
import { Subject, tap } from 'rxjs';

@Directive({
  selector: '[qtDisableAfterClick]',
  standalone: true,
})
export class DisableAfterClickDirective implements OnDestroy {
  private readonly matButton =
    inject(MatButton, { optional: true }) ??
    inject(MatIconButton, { optional: true }) ??
    inject(MatFabButton, { optional: true }) ??
    inject(MatMiniFabButton, { optional: true });
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  @Input('qtDisableAfterClickDuration') duration = 500;

  private timeoutCallback: number = null;

  private readonly disableSubject = new Subject<void>();
  private readonly disableSubscription = this.disableSubject
    .asObservable()
    .pipe(
      tap(() => {
        clearTimeout(this.timeoutCallback);

        if (isNonNullable(this.matButton)) {
          this.matButton.disabled = true;
          this.changeDetectorRef.markForCheck();

          this.timeoutCallback = window.setTimeout(() => {
            this.matButton.disabled = false;
            this.changeDetectorRef.markForCheck();
          }, this.duration);
        }
      }),
      takeUntilDestroyed()
    )
    .subscribe();

  @HostListener('click')
  setDisabledState(): void {
    this.disableSubject.next();
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutCallback);
  }
}
